// extracted by mini-css-extract-plugin
export var explainable = "_ja-a";
export var printerCard = "_ja-1";
export var printerCardConfigured = "_ja-2";
export var printerCardError = "_ja-3";
export var printerCardsContainer = "_ja-0";
export var printerIcon = "_ja-8";
export var printerIconConfigured = "_ja-5";
export var printerIconContainer = "_ja-4";
export var printerIconError = "_ja-6";
export var printerIconUnconfigured = "_ja-7";
export var workstationsTableCard = "_ja-9";